import { all } from 'redux-saga/effects';
import contract from './lease_contract/saga';
import auth from './auth/saga';
import token from './token/saga';
import user from './user/saga';
import webpay from './webpay/saga';
import mail from './mail/saga';
import coupon from './coupon/saga';
import dashboard from './dashboard/saga';
import assets from './assets/saga';
import downloadDocs from './downolad_docs/saga';

export default function* rootSaga() {
  yield all([
    ...contract,
    ...auth,
    ...token,
    ...user,
    ...webpay,
    ...mail,
    ...coupon,
    ...dashboard,
    ...assets,
    ...downloadDocs,
  ]);
}